import React from 'react';
import 'header-pattern/dist/foundation.css';
import { authService } from '../services/auth/authService';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
 
const Header: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const profile = useSelector((state: any) =>
   state.profile.profile
  );
  const firstName = profile?.empFirstName || '';
  const fullName = `${firstName}`.trim();
  const handleSignOff = async () => {
    authService.logout();
  };
 
  const getRoute = (pathname: string): string => {
    if (pathname.includes('/admin')) return 'admin';
    if (pathname.includes('/citizenship')) return 'citizenship';
    if (pathname.includes('/tuition')) return 'tuition';
    return 'citizenship';
  };
 
  const handleLogoClick = () => {
    const route = getRoute(location.pathname);
    navigate(`/${route}`);
  };
 
  return (
    <header className="ds-header" data-ds-theme="vessel" data-ds-variant="compact" data-ds-version="2">
      <div className="ds-header__layout">
        <div className="ds-header__top-bar flex flex-1 items-center">
          <div className="ds-header__branding">
            <button
              className="ds-header__logo"
              onClick={handleLogoClick}
              data-analytics-type="image"
              data-analytics-click="kp-logo"
              style={{ background: 'none', border: 'none', cursor: 'pointer' }}
            >
              <img
                className="ds-header__logo-img ds-header__logo-img--mobile block sm:hidden"
                src="/assets/images/KP_Signature_Stacked_white_0817.png"
                width="150"
                height="40"
                alt="Kaiser Permanente Home - Mobile"
              />
              
              <img
                className="ds-header__logo-img ds-header__logo-img--desktop hidden sm:block"
                src="/assets/images/KP_Signature_white_0817.png"
                width="374"
                height="42"
                alt="Kaiser Permanente Home"
              />
            </button>
          </div>
          <div className="flex items-center gap-4">
            {fullName && (
              <span data-testid="welcome-message" className="mr-2 text-white ">Welcome, {fullName}</span>
            )}
            <button className="button -primary" onClick={handleSignOff}>Sign Off</button>
          </div>
        </div>
      </div>
    </header>
  );
};
 
export default Header;
 